import { defineMessages } from 'react-intl';

export default defineMessages({
    violationDetailCount: {
        id: 'quoteandbind.rv.directives.templates.convictions.rv-edit-driver.Violation Details:',
        defaultMessage: 'Violation Details:',
    },
    vioTypeOfViolation: {
        id: 'quoteandbind.rv.directives.templates.rv-driver.Type Of Violation',
        defaultMessage: 'Type Of Violation'
    },
    vioDateOfViolation: {
        id: 'quoteandbind.rv.directives.templates.rv-driver.Date Of Violation',
        defaultMessage: 'Date Of Violation'
    },
    vioViolationDescription: {
        id: 'quoteandbind.rv.directives.templates.rv-driver.Violation Description',
        defaultMessage: 'Violation Description'
    },
    vioPenaltyPoints: {
        id: 'quoteandbind.rv.directives.templates.rv-driver.Penalty Points',
        defaultMessage: 'Penalty Points'
    }

});
